import React from "react";
import SettingsSection from "../SettingsSection";

export default function VerificationSection({
  verificationMode,
  setVerificationMode,
  verificationTitle,
  setVerificationTitle,
  verificationDescription,
  setVerificationDescription,
  verificationFooter,
  setVerificationFooter,
  verificationButtonLabel,
  setVerificationButtonLabel,
  isOpen,
  setIsOpen,
}) {
  const isOauth = verificationMode === "oauth";

  return (
    <SettingsSection>
      <p
        className="help-text"
        style={{ color: "#7b6f62", fontSize: "0.8rem", marginBottom: "15px" }}
      >
        Customize the public verification embed. After saving, run{" "}
        <code>/setup-verify</code> again to refresh the Discord panel (and pass{" "}
        <code>mode</code> there if you want to switch methods).
      </p>

      <label className="input-label">METHOD</label>
      <select
        value={verificationMode}
        onChange={(e) => setVerificationMode(e.target.value)}
        className="settings-input"
      >
        <option value="button">In-Discord button (recommended)</option>
        <option value="oauth">Website OAuth</option>
      </select>
      <p
        className="help-text"
        style={{ color: "#7b6f62", fontSize: "0.75rem", marginTop: "6px", marginBottom: "15px" }}
      >
        {isOauth
          ? "Members open kamigrove.com, sign in with Discord, then Kami applies roles."
          : "Members click the green button in Discord and get roles immediately - no website needed."}
      </p>

      <label className="input-label">TITLE</label>
      <input
        type="text"
        value={verificationTitle}
        onChange={(e) => setVerificationTitle(e.target.value)}
        className="settings-input"
        maxLength={256}
      />

      <label className="input-label">DESCRIPTION</label>
      <textarea
        value={verificationDescription}
        onChange={(e) => setVerificationDescription(e.target.value)}
        className="settings-input"
        rows={4}
        maxLength={2000}
      />

      <label className="input-label">FOOTER</label>
      <input
        type="text"
        value={verificationFooter}
        onChange={(e) => setVerificationFooter(e.target.value)}
        className="settings-input"
        maxLength={2048}
      />

      <label className="input-label">BUTTON LABEL</label>
      <input
        type="text"
        value={verificationButtonLabel}
        onChange={(e) => setVerificationButtonLabel(e.target.value)}
        className="settings-input"
        maxLength={80}
      />
    </SettingsSection>
  );
}
